<template>
  <div>
    <el-drawer
      title="编辑广告系列"
      size="1200px"
      append-to-body
      :visible="editCampaignShow"
      @close="close"
      @opened="openInit"
      v-loading="adsInfoLoading"
    >
      <div class="p-[20px]">
        <campaign
          ref="campaign"
          :currentData="adsMsg"
          :createAdAccount="createAdAccount"
          :enumConstants="enumConstants"
          @change="setAdsMsg"
        />
      </div>
      <div class="absolute right-3 bottom-5">
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="sure"
          >确 定</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>
<script>
import campaign from '../components/campaign.vue';
import { adDetail, updateAd } from '@/api/google/create';
import { bidStrategy, budgetTypes } from '@/views/google/create/index.js';
import { mapState } from 'vuex';

export default {
  components: {
    campaign,
  },
  props: {
    editCampaignShow: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('google', ['createAdAccount']),
  },
  data() {
    return {
      adsMsg: {},
      enumConstants: {
        bidStrategy,
        budgetTypes,
      },
      adsInfoLoading: false,
      oldAdsMsg: {},
    };
  },
  methods: {
    // 初始化弹窗
    openInit() {
      this.getAdsInfo();
    },
    // 获取广告信息
    getAdsInfo() {
      console.log(this.currentRow);
      let params = {
        level: 'campaign',
        accountId: this.createAdAccount.id,
        accountName: this.createAdAccount.name,
        campaignId: this.currentRow.campaign_id,
      };
      this.adsInfoLoading = true;
      adDetail(params)
        .then((res) => {
          if (res.code == 0) {
            this.adsMsg = res.data.campaign;
            // this.oldAdsMsg = JSON.parse(JSON.stringify(res.data.campaign));
            this.adCommon = { ...res.data };
          }
          console.log(this.adsMsg);
        })
        .finally(() => {
          this.adsInfoLoading = false;
        });
    },
    //关闭弹窗
    close() {
      this.$emit('update:editCampaignShow', false);
    },
    // 接收参数
    setAdsMsg(val) {
      console.log(val, 'cccccccccccccccccccc');
      this.adsMsg = { ...this.adsMsg, ...val };
    },
    //点击确定
    async sure() {
      const validate = await this.$refs.campaign.checkForm();
      if (!validate) {
        return false;
      }
      console.log(this.adsMsg);
      this.$showLoading();
      updateAd({ ...this.adCommon, campaign: this.adsMsg }).then((res) => {
        this.$hideLoading();
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      });
    },
  },
};
</script>
